module.exports = __webpack_public_path__ + "static/activities-pic-03-630418fb095fe59b4df315b529baf1ec.jpg";